export const AccountIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M9.1001 12.7057C10.6991 12.7058 11.9054 13.107 12.75 13.7718C13.5441 14.3969 13.9676 15.2164 14.1025 16.0187L14.1253 16.179L14.131 16.2555C14.1386 16.6357 13.8566 16.9672 13.471 17.014C13.0855 17.0607 12.7327 16.8062 12.6491 16.4354L12.6361 16.3597L12.606 16.1766C12.5136 15.7466 12.2729 15.3049 11.8223 14.9502C11.3048 14.5429 10.4519 14.2064 9.1001 14.2064C7.76567 14.2064 6.91709 14.5402 6.39909 14.9453C5.88294 15.3491 5.64017 15.8647 5.57878 16.341L4.83496 16.245L4.09115 16.1497C4.20006 15.3044 4.63068 14.4248 5.47461 13.7645C6.31678 13.1056 7.51595 12.7057 9.1001 12.7057Z"
        fill="#282828"
      />
      <path
        d="M5.57878 16.341C5.52585 16.7518 5.14975 17.0417 4.73893 16.9888C4.32835 16.9357 4.03843 16.5603 4.09115 16.1497L5.57878 16.341Z"
        fill="#282828"
      />
      <path
        d="M9.12533 0.980469C13.6828 0.980469 17.3757 4.67337 17.3757 9.23079C17.3756 10.6107 17.0372 11.9237 16.4284 13.0695C16.234 13.4352 15.7793 13.5739 15.4136 13.3796C15.0481 13.1851 14.9093 12.7312 15.1035 12.3656C15.5975 11.4357 15.875 10.3645 15.875 9.23079C15.875 5.5018 12.8544 2.48112 9.12533 2.48112C5.39629 2.48112 2.37565 5.50181 2.37565 9.23079C2.37566 10.2151 2.58775 11.1527 2.96729 11.9904L3.13981 12.3428L3.17236 12.4128C3.31477 12.7651 3.1699 13.1748 2.8265 13.356C2.48293 13.5372 2.06275 13.4254 1.85238 13.1086L1.81331 13.0426L1.70426 12.8278C1.17329 11.7436 0.875005 10.5175 0.875 9.23079C0.875 4.67337 4.56787 0.980473 9.12533 0.980469Z"
        fill="#282828"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.10091 5.20573C11.031 5.20591 12.597 6.77138 12.597 8.70264C12.5968 10.6337 11.0309 12.1986 9.10091 12.1987C7.17002 12.1987 5.6034 10.634 5.60319 8.70264C5.60319 6.77111 7.16991 5.20573 9.10091 5.20573ZM9.10091 6.70638C7.99775 6.70638 7.10384 7.60013 7.10384 8.70264C7.10405 9.80497 7.99789 10.6989 9.10091 10.6989C10.2027 10.6987 11.0961 9.80502 11.0964 8.70264C11.0964 7.60008 10.2029 6.70656 9.10091 6.70638Z"
        fill="#282828"
      />
    </svg>
  );
};
